import {
    ChangeGeneralSettingActionType,
    ChangeLimitSettingsActionType,
    ChangeFormSettingsFailureActionType,
    ChangeFormSettingsRequestActionType,
    ChangeFormSettingsSuccessActionType,
    FormSettingsTypes,
    InitFormSettingsActionType,
    ChangeNotificationSettingsActionType,
    ChangeNativeFormSettingsRequestActionType,
    ChangeSaveProgressSettingsActionType,
    ChangeConfirmationSettingsActionType,
} from "./types";
import { ActionCreator } from "./../types/store-types";

export const changeFormSettingsRequest: ActionCreator<ChangeFormSettingsRequestActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_FORM_SETTINGS_REQUEST,
    payload,
});

export const changeFormSettingsSuccess: ActionCreator<ChangeFormSettingsSuccessActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_FORM_SETTINGS_SUCCESS,
    payload,
});

export const changeFormSettingsFailure: ActionCreator<ChangeFormSettingsFailureActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_FORM_SETTINGS_FAILURE,
    payload,
});

export const initFormSettings: ActionCreator<InitFormSettingsActionType> = payload => ({
    type: FormSettingsTypes.INIT_FORM_SETTINGS,
    payload,
});

export const changeGeneralSettingsRequest: ActionCreator<ChangeGeneralSettingActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_GENERAL_SETTING_REQUEST,
    payload,
});

export const changeLimitsSettings: ActionCreator<ChangeLimitSettingsActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_LIMITS_SETTING,
    payload,
});

export const changeNotificationSettings: ActionCreator<ChangeNotificationSettingsActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_NOTIFICATIONS_SETTING,
    payload,
});

export const changeSaveProgressSettings: ActionCreator<ChangeSaveProgressSettingsActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_SAVE_PROGRESS_SETTING,
    payload,
});

export const changeConfirmationSettings: ActionCreator<ChangeConfirmationSettingsActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_CONFIRMATION_SETTING,
    payload,
});

export const changeNativeFormSettingsRequest: ActionCreator<ChangeNativeFormSettingsRequestActionType> = payload => ({
    type: FormSettingsTypes.CHANGE_NATIVE_SETTING_REQUEST,
    payload,
});
